"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _SubmitArtPopup = require("@quixeltools/quixel-ui-library/dist/components/common/gallery/SubmitArtPopup");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var textInput = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(1)
});

var submitButton = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(2),
  textAlign: "center",
  display: "block"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  marginLeft: (0, _css.unitRem)(1),
  display: "inline",
  marginTop: "unset",
  textAlign: "left"
}));

var textMsg = (0, _glamor.css)({
  display: "block",
  marginTop: (0, _css.unitRem)(1),
  fontSize: (0, _css.unitRem)(0.75)
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  display: "inline",
  fontSize: "0.9375em",
  marginTop: "unset"
}));

var foot = (0, _glamor.css)({
  display: "block",

  marginTop: (0, _css.unitRem)(2),
  textAlign: "center",
  color: _css.colors.gray
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  textAlign: "unset"
}));

var heading = (0, _glamor.css)({
  display: "block",
  position: "relative"
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "inline-block",
  paddingLeft: "1.5rem"
}), (0, _css.minWidth)(_css.breakpoints.xlarge)({}));

var h1 = (0, _glamor.css)({
  fontWeight: 700,
  fontSize: (0, _css.unitRem)(1.25),
  letterSpacing: "-2px",

  marginBottom: (0, _css.unitRem)(1.25)
  // textAlign: 'center',
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1.875,
    mediumLarge: [1.4, 1.875]
  }
}), (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  // textAlign: 'left',
  marginBottom: (0, _css.unitRem)(0.5)
}));

var ChangePasswordPopup = function ChangePasswordPopup(props) {
  return _react2.default.createElement(
    _Form2.default,
    {
      className: _SubmitArtPopup.popup,
      onSubmit: props.onSubmit,
      message: props.message,
      error: props.error,
      onChildRef: props.onChildRef
    },
    _react2.default.createElement(
      "div",
      {
        style: { marginBottom: "2rem", display: "flex", alignItems: "center" }
      },
      _react2.default.createElement("img", { src: props.icon, alt: "", className: _SubmitArtPopup.icon }),
      _react2.default.createElement(
        "div",
        { className: heading },
        _react2.default.createElement(
          "h1",
          { className: h1 },
          "Change Password"
        ),
        _react2.default.createElement(
          "p",
          { className: _SubmitArtPopup.p },
          "Change the password of your Quixel account."
        )
      )
    ),
    _react2.default.createElement(
      "div",
      { className: textInput },
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        label: "Old Password",
        type: "password",
        value: "",
        autoFocus: true
      }, props.oldPasswordInputProps))
    ),
    _react2.default.createElement(
      "div",
      { className: textInput },
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        label: "New Password",
        type: "password",
        value: ""
      }, props.passwordInputProps))
    ),
    _react2.default.createElement(
      "div",
      { className: textInput },
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        label: "Confirm Password",
        type: "password"
      }, props.repeatPasswordInputProps))
    ),
    _react2.default.createElement(
      "div",
      { className: foot },
      _react2.default.createElement(
        "span",
        { className: textMsg },
        "This changes the password across all Quixel services."
      ),
      _react2.default.createElement(_Button2.default, {
        className: submitButton,
        mode: "secondary",
        type: "submit",
        label: "Change",
        loading: props.submitting,
        disabled: !!props.message
      })
    )
  );
};

exports.default = ChangePasswordPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangePasswordPopup/index.jsx
// module id = 2601
// module chunks = 0